import { supabase } from './api'

export const revalidate = 0

export async function getAllData() {
    const { data, error } = await supabase.from('studentgradeinmonthlistview').select();

    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }


  export async function getStudentIdData(id) {

    const { data, error } = await supabase.from('studentgradeinmonthlistview').select()
    .eq('studentId', id);
    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }

  export async function getDataWithType(type) {
    const { data, error } = await supabase.from('studentgradeinmonthlistview').select().eq('type',type);

    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }

  

  export async function getIdData(id) {
    const { data, error } = await supabase.from('studentgradeinmonthlistview').select()
    .eq('id', id);
    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }

  export async function getDataForMonths(studentId,month) {
    const { data, error } = await supabase.from('studentgradeinmonthlistview').select()
    .eq('studentId', studentId)
    .eq('month', month);
    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }

  export async function addData(adata) {
    const { data, error } = await supabase.from('studentgradeinmonthlistview').insert(adata).select();
    console.log("gradeInMonth",data,error);
    if (error) {
      throw new Error('Failed to fetch data')
    }
    return data;
  }

  export async function updateData(udata) {
    //console.log("udata",udata);
    const { data, error } = await supabase.from('studentgradeinmonthlistview').update(udata).eq('id', udata.id).select();
    console.log("error",error,data);
    if (error) {

      throw new Error('Failed to fetch data')

    }

    return data;
  }

  export async function deleteIdData(id) {
    const { data, error } = await supabase.from('studentgradeinmonthlistview').delete()
    .eq('id', id);
    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }